var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M817.230769 393.846154h-610.461538c-15.753846 0-29.538462 13.784615-29.538462 29.538461V886.153846c0 55.138462 43.323077 98.461538 98.461539 98.461539h472.615384c55.138462 0 98.461538-43.323077 98.461539-98.461539V423.384615c0-15.753846-13.784615-29.538462-29.538462-29.538461zM512 905.846154v-78.769231c64.984615 0 118.153846-53.169231 118.153846-118.153846s-53.169231-118.153846-118.153846-118.153846c-31.507692 0-61.046154 13.784615-82.707692 35.446154l47.261538 47.261538c5.907692 5.907692 1.969231 17.723077-7.876923 17.723077h-143.753846c-5.907692 0-9.846154-3.938462-9.846154-9.846154v-143.753846c0-7.876923 9.846154-13.784615 17.723077-7.876923L374.153846 571.076923c37.415385-35.446154 86.646154-57.107692 139.815385-57.107692 108.307692 0 196.923077 88.615385 196.923077 196.923077S620.307692 905.846154 512 905.846154z m384-708.923077H649.846154V118.153846c0-43.323077-35.446154-78.769231-78.769231-78.769231h-118.153846c-43.323077 0-78.769231 35.446154-78.769231 78.769231v78.769231H128c-15.753846 0-29.538462 13.784615-29.538462 29.538461v59.076924c0 15.753846 13.784615 29.538462 29.538462 29.538461h768c15.753846 0 29.538462-13.784615 29.538462-29.538461v-59.076924c0-15.753846-13.784615-29.538462-29.538462-29.538461zM571.076923 196.923077h-118.153846V137.846154c0-11.815385 7.876923-19.692308 19.692308-19.692308h78.76923c11.815385 0 19.692308 7.876923 19.692308 19.692308v59.076923z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndelete);
export default __webpack_public_path__ + "static/media/undelete.362ee9078f12a7b307bf1a1f351694d7.svg";
export { ForwardRef as ReactComponent };